import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import CsvParse from '@vtex/react-csv-parse'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import ArchiveValues from './ArchiveValues'
import {withRouter} from 'react-router'
import MdBackup from 'react-icons/lib/md/backup'

@withMutation(gql`
  mutation insertProducts($products: [SSProductInput]) {
    insertProducts(products: $products) {
      success
    }
  }
`)
@withMessage
@withRouter
export default class AddProducts extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func
  }

  state = {data: null}

  getKeys() {
    return ['productCode', 'description', 'price']
  }

  handleData = data => {
    this.setState({data})
    this.props.showMessage('Documento cargado')
  }

  @autobind
  async save() {
    this.setState({loading: true, errorMessages: null})
    try {
      console.log(this.state.data)
      await this.props.insertProducts({products: this.state.data}, {refetchQueries: ['ssProducts']})
      this.props.showMessage('Success')
      this.props.router.push('/allProducts')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderInput() {
    return (
      <CsvParse
        keys={this.getKeys()}
        separators={[',', ';']}
        onDataUploaded={this.handleData}
        render={onChange => (
          <div className={styles.upload}>
            <label className={styles.label} htmlFor="image">
              Cargar productos
            </label>
            <input
              className={styles.input}
              id="image"
              name="image"
              type="file"
              onChange={onChange}
            />
          </div>
        )}
      />
    )
  }

  renderButton() {
    return (
      <div className={styles.button}>
        <Button
          primary
          loading={this.state.loading}
          onClick={this.save}
          disabled={!this.state.data}
        >
          Guardar Productos
        </Button>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h3 className={styles.title}>Subir datos de productos</h3>
              </div>
              <div className="col-xs-12 col-sm-4 end-md">
                <MdBackup />
              </div>
            </div>
          </div>
          <div className="content">
            <div className="row">
              <div className="col-xs-12 col-sm-3">{this.renderInput()}</div>
              <div className="col-xs-12 col-sm-3">{this.renderButton()}</div>
            </div>
            <ArchiveValues value={this.state.data} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/Add/AddProducts/index.js